<template>
	<div class="list-container">
		<div class="empty-indicator" v-if="isEmpty">{{ this.emptyMessage }}</div>
		<ul class="list-content">
			<div class="grid grid-cols-2 gap-4 gap-y-4 ">
				<template v-for="item in this.listData" :key="item.id">
					<!-- todo: 首图为主、缩略图为辅 -->
					<VideoItem
						:imageURL="item.thumbnail.thumbnail"
						:videoThumbnailURL="item.file.thumbnail"
						:title="item.title"
						:desc="item.abstract"
						:url="'/vlog/video/' + item.id"
						:date="item.display_date"
						:showDesc="showDesc"
						:itemData="item"
					></VideoItem>
				</template>
			</div>
		</ul>
		<InfiniteLoading class="infinite-loader" @infinite="loadData">
			<template #complete>
				<div class="loader-indicator text-center my-3 text-xs text-gray-400">
					<!-- <span>加载完成</span> -->
				</div>
			</template>
			<template #error="{ retry }">
				<div class="loader-indicator text-center my-3 text-xs">
					<button @click="retry">重试</button>
				</div>
			</template>
			<template #spinner>
				<div class="loader-indicator text-center my-3 text-xs py-1">
					<pulse-loader
						loading="loading"
						color="#cccccc"
						size="6px"
					></pulse-loader>
				</div>
			</template>
		</InfiniteLoading>
	</div>
</template>

<script>
import InfiniteLoading from "v3-infinite-loading";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import "v3-infinite-loading/lib/style.css"; //required if you're not going to override default slots
import axios from "axios";
import VideoItem from "@/components/vlog/components/VideoItem.vue";

export default {
	name: "VlogContentList",
	props: {
		// 内容表、商品表
		contentType: {
			type: String,
			default: "content",
		},
		// 内容表假设需要mold type、商品表假设需要其他类型
		type: {
			type: String,
			default: "",
		},
		categoryID: {
			// 分类ID
			type: String,
			default: "",
		},
		sortBy: {
			type: String,
			default: "sort",
		},
		order: {
			type: String,
			default: "desc",
		},
		keywords: {
			type: String,
			default: "",
		},
		emptyIndicatorText: {
			type: String,
			default: "没有内容",
		},
		showDesc: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		InfiniteLoading,
		PulseLoader,
		VideoItem,
	},
	data() {
		return {
			listData: [],
			nextPage: 1,
			isEmpty: false,
		};
	},
	computed: {
		emptyMessage() {
			console.log(this.emptyIndicatorText);
			return this.emptyIndicatorText;
		},
	},
	methods: {
		reset() {},
		constructRequestParams() {
			return {
				mold_types: "2",
				is_not_show_description: 1,
				page_size: 40,
				page: this.nextPage,
				cat_ids: "" + this.categoryID,
				sort_by: this.sortBy,
				sort: this.order,
				keywords: this.keywords,
				language_type: localStorage.getItem("lang") || "",
				// mold_types-----文章类型，多个用逗号分割
				// cat_ids----文章分类id，多个用逗号分割
				// sort_by---排序字段，默认sort降序
				// sort----排序规则；desc、asc
				// page_size---分页大小，默认20
				// page--页码
				// is_not_show_description----1不显示内容 0显示，默认显示
			};
		},
		loadData(state) {
			this.isEmpty = false;
			state.loading();
			const url = "/api/gatewayCms/articles/list";
			const that = this;
			// console.log('request: ' + JSON.stringify(this.constructRequestParams()));
			axios
				.get(url, {
					params: this.constructRequestParams(),
				})
				.then((response) => {
					// that.loading = false;
					const responseData = response.data;
					that.nextPage += 1;
					if (responseData.data?.data?.length > 0) {
						that.listData.push(...responseData.data.data);
						// console.log(that.listData);

						state.loaded();
					} else {
						// finish.
						this.isEmpty = that.listData?.length == 0;
						state.complete();
					}
				})
				.catch((error) => {
					// error;
					// that.loading = false;
					// console.log(error);
					state.error(error);
				});
		},
	},
	mounted() {
		// 1. 这个列表直接通过load-more组件进行加载即可
	},
};
</script>
<style scoped>
.list-container {
	padding-bottom: 24px;
}
.empty-indicator {
	text-align: center;
	padding: 88px;
	font-size: 13px;
	color: #aaaaaa;
}
</style>
